import React, { useState, useEffect } from 'react'
import DataGrid from '../../../../components/DataGrid'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { consultar } from '../../../../util/AcessoApi'
import { HeaderCadastro } from '../../../../components/Headers'

const Consulta = props => {
    const [data, setData] = useState([])


    const columns = React.useMemo(
        () => [{
            id: 'consulta-pre-anestesico',
            columns: [
                {
                    Header: 'Código',
                    accessor: 'id',
                    html: item => <span>{item.id}<div className='circulo-consulta' style={item.liberado == "SIM" ? { background: 'rgb(0, 173, 98)' } : { background: 'rgb(173, 0, 0)' }}></div></span>,
                    ordenamento: {
                        tipo: 'numero',
                        ativo: true,
                        modo: 'desc',
                    }
                },
                {
                    Header: 'Identificação',
                    accessor: 'cpf',
                    visivel: true,
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'Paciente',
                    accessor: 'beneficiario',
                    visivel: true,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'beneficiario',
                        idColuna: 'beneficiario_id'
                    }
                },
                {
                    Header: 'Operadora Saúde',
                    accessor: 'operadora_saude',
                    visivel: true,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'operadora_saude',
                        idColuna: 'questionario_paciente.operadora_saude_id'
                    }
                },
                {
                    Header: 'Estabelecimento Saúde',
                    accessor: 'estabelecimento_saude',
                    visivel: true,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'estabelecimento_saude',
                        idColuna: 'questionario_paciente.estabelecimento_saude_id'
                    }
                },

                {
                    Header: 'Sócio',
                    accessor: 'socio',
                    visivel: true,
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'socio',
                        idColuna: 'socio_id'
                    }
                },
                {
                    Header: 'Liberado P/ Cirurgia?',
                    accessor: 'liberado',
                    visivel: true,
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'Data Hora Liberação',
                    accessor: 'data_registro',
                    ordenamento: {
                        tipo: 'data'
                    }
                }
            ]
        }], []
    )

    return (
        <>
            <div>
                <DataGridAlternativa removerTotalPaginas data={data} columns={columns} setData={setData} acoes={true} caminhoBase='/preanestesico/consultapreanestesico' caminhoConsultaFiltros='/preanestesico/consultapreanestesicoPaginacao' modulo={props.modulo} titulo={'Consulta Pré-Anestésica'}
                    tituloLista={'Lista Consulta Pré-Anestésica'} icone={'icon-Tablet'} preAnestesico={true} />
            </div>
        </>
    )
}

export default Consulta